import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Event } from '@angular/router';
import {
  debounce,
  debounceTime,
  distinctUntilChanged,
  Subscription,
  throttle,
  throttleTime,
} from 'rxjs';

@Component({
  selector: 'app-poshvine-input-box',
  templateUrl: './input-box.component.html',
  styleUrls: ['./input-box.component.scss'],
})
export class InputBoxComponent {
  @Input() type: 'number' | 'text' = 'text';
  @Input() isImageEnabled = false;
  @Input() imageSrcLeft = '';
  @Input() imageSrcRight = '';
  @Input() placeholder = '';
  @Input() buttonText = 'Submit';
  @Input() isButtonEnabled = false;
  @Input() isNavButton = false;
  @Input() isChipEnabled = false;
  @Input() chipText = '';
  @Input() chipType: 'primary' | 'secondary' = 'primary';
  @Input() formModelInput = '';
  @Input() maxLength = 1000;
  formModelDebouncer: EventEmitter<any> = new EventEmitter<any>();
  @Output() formModelInputChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() clickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() submitButtonEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() leftButtonClickEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() rightButtonClickEvent: EventEmitter<any> = new EventEmitter<any>();
  subscription: Subscription;

  constructor() {
    this.subscription = this.formModelDebouncer
      .pipe(debounceTime(500), distinctUntilChanged(), throttleTime(10))
      .subscribe((resp: any) => {
        // console.log(resp,'>>>>> input checl');
        this.formModelInputChange.next(resp);
      });
  }

  public handleClickAction(e: any) {
    if (this.isNavButton) {
      this.clickEvent.emit();
      return;
    }
    e?.stopPropagation();
  }
  onKeyPress(event: any) {
    // console.log(event && event.target && event.target.value);
    this.formModelDebouncer.next(event && event.target && event.target.value);
  }
  emitClickEvent(eve:any){
    this.submitButtonEvent.emit(eve);
  }
  leftBtnClick(){
    this.leftButtonClickEvent.emit(true);
  }
  rightBtnClick(){
    this.rightButtonClickEvent.emit(true);
  }
  private ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
